'use strict';

module.exports = function () {};



//////////////////
// WEBPACK FOOTER
// ./lib/auth/noop.js
// module id = 67
// module chunks = 0